import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

// Firebase v8 config
const firebaseConfig = {
    apiKey: "AIzaSyD7aK6zz83EdISJYNYDGDnunaEErcmhUoo",
    authDomain: "ctcae5-5e259.firebaseapp.com",
    databaseURL: "https://ctcae5-5e259.firebaseio.com",
    projectId: "ctcae5-5e259",
    storageBucket: "ctcae5-5e259.appspot.com",
    messagingSenderId: "455824347656"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// Firestore reference
const firestore = firebase.firestore();

// Optional: set Firestore settings
const settings = { timestampsInSnapshots: true };
firestore.settings({ ...settings, merge: true });

// Render React app
ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);

// Register service worker
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js